// Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import { FaSquareXTwitter } from "react-icons/fa6";
import {
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
  FaWhatsapp,
} from "react-icons/fa";
import ClotaLogoHD from "../images/ClotaHDLogoRound.png";
import WhatsApp from "./whatsApp";
import { ScrollTop } from "primereact/scrolltop";
import "./Footer.css";

function Footer() {
  const ThisYear = new Date().getFullYear();
  return (
    <>
      <WhatsApp />
      <div className="">
        <ScrollTop
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            backgroundColor: "#007bff", // Button ka color
            color: "#fff",
            borderRadius: "50%", // Circle shape
            width: "50px",
            height: "50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            cursor: "pointer",
            zIndex: 9999,
          }}
        />
      </div>

      <footer className="footer">
        <div className="footer-grid">
          <div className="footer-col logo-col">
            <img
              src={ClotaLogoHD}
              alt="clotalogo"
              className="footer-logo-img"
            />
          </div>

          {/* About */}
          <div className="footer-col">
            <h5 className="footer-heading">About Clota</h5>
            <p className="footer-text">
              Over a decade of experience and implementing best solutions in
              Database Technologies and Web Development. It's our passion for
              technologies which lead us here.
            </p>
          </div>

          {/* Community */}
          <div className="footer-col">
            <h5 className="footer-heading">Clota Community</h5>
            {/* <Link
              to="https://blog.clotatech.com/"
              target="_clota"
              className="Text-Gradient">
              <b>Clota Blog</b>
            </Link> */}
            <Link to="/ContactUsForm" target="_clota" className="Text-Gradient">
              <b>Quick Connect</b>
            </Link>
            <Link to="/ContactUsForm" target="_clota" className="Text-Gradient">
              <b>Having Queries talk to us</b>
            </Link>
          </div>

          {/* Get in Touch with Social Icons */}
          <div className="footer-col">
            <h5 className="footer-heading">Get in Touch</h5>
            <div className="footer-social-icons">
              <Link
                to="https://www.facebook.com/ClotaTech"
                target="_clota"
                className="social-icon facebook">
                <FaFacebookSquare />
              </Link>
              <Link
                to="https://www.instagram.com/ClotaTech"
                target="_clota"
                className="social-icon instagram">
                <FaInstagram />
              </Link>
              <Link
                to="https://twitter.com/ClotaTech"
                target="_clota"
                className="social-icon twitter">
                <FaSquareXTwitter />
              </Link>
              <Link
                to="https://www.linkedin.com/company/clota-tech/"
                target="_clota"
                className="social-icon linkedin">
                <FaLinkedin />
              </Link>
              <Link
                to="https://api.whatsapp.com/send?phone=919490384177&text=Hi, i'm enquiriying through your Clotatech Site"
                target="_clota"
                className="social-icon whatsapp">
                <FaWhatsapp />
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar with Terms/Privacy/CopyRight */}
        <div className="footer-legal">
          <div className="footer-copy">
            <b>© Copyright {ThisYear} Clota Technology - All Rights Reserved</b>
          </div>
          <div className="footer-legal-links">
            <Link to="/TermsAndCondition" target="_clota">
              <b>Terms & Condition</b>
            </Link>
            <span className="legal-divider">|</span>
            <Link to="/PrivacyPolicy" target="_clota">
              <b>Privacy Policy</b>
            </Link>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
